
import Vue from "vue";
import { State } from "vuex-class";
import { Component, Watch } from "vue-property-decorator";
import moment from "moment";
import { baseAPI } from "@/functions/apibase.function";

@Component({
  components: {},
})
export default class App extends Vue {
  @State("locale")
  private locale!: string;

  @Watch("locale")
  private onLocaleChanged() {
    this.$i18n.locale = this.locale;
    moment.locale(this.locale);
  }

  private created() {
    this.$i18n.locale = this.locale;
    moment.locale(this.locale);
    this.websocket();
  }

  private websocket() {
    (window as any).socket = new WebSocket(
      `wss://${baseAPI
        .replaceAll("https://", "")
        .replaceAll("http://", "")}/admin-job-fair-websocket`
    );
    (window as any).socket.onopen = () => {
      (window as any).socket.send(
        JSON.stringify({
          slug: this.$route.params.slug,
        })
      );
    };
    (window as any).socket.onclose = () => {
      this.websocket();
    };
    (window as any).socket.onerror = (event) => {
      console.log("onerror", event);
    };
    (window as any).socket.onmessage = (event) => {
      console.log("onmessage", event?.data);
    };
  }
}
